module.exports = __webpack_public_path__ + "static/media/LogoNavionics.3f7fed51.svg";